import Vue from 'vue'
import router from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken, setToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/verify-code', '/client-register', '/clogin',
  '/client-index', '/client-repwd', '/wx-play'] // no redirect whitelist

router.beforeEach(async(to, from, next) => {
  NProgress.start()
  document.title = getPageTitle(to.meta.title)

  if (whiteList.indexOf(to.path) !== -1) {
    next()
  } else {
    const hasToken = getToken()
    if (hasToken) {
      const hasPermissions = store.getters.permissions && store.getters.permissions.length > 0
      if (hasPermissions) {
        next()
      } else {
        try {
          const loginInfo = await store.dispatch('user/getInfo')
          const accessRoutes = await store.dispatch('router-permission/generateRoutes', loginInfo)
          router.addRoutes(accessRoutes)
          next({ ...to, replace: true })
        } catch (error) {
          await store.dispatch('user/resetToken')
          Vue.prototype.alert('获取登录信息失败，请稍后再试')
          NProgress.done()
        }
      }
    } else {
      const code = Vue.prototype.Utils.getUrlKey('code')
      const url = location.href
      if (url.startsWith('https://wxfwh.wa08.cn') || url.includes('wx-')) {
        if (code) {
          if (process.env.NODE_ENV === 'development') { // for test
            setToken('ea7266c3-4a80-42bc-bb9b-c91269f79173')
            await store.dispatch('user/getInfo').then(() => {
              next()
            }).catch(() => {
              Vue.prototype.alert('获取登录信息失败，请检查您的网络')
              NProgress.done()
            })
          } else {
            await store.dispatch('user/wxfwhLogin', code)
              .then(async(resp) => {
                if (resp.success) {
                  await store.dispatch('user/wxfwhGetInfo').then(() => {
                    next()
                  }).catch(() => {
                    Vue.prototype.alert('获取登录信息失败，请检查您的网络')
                    NProgress.done()
                  })
                } else {
                  localStorage.setItem('wxLoginInfo', JSON.stringify(resp.obj))
                  next()
                }
              })
              .catch(() => {
                Vue.prototype.alert('验证身份失败，请您从微信服务号进入')
                NProgress.done()
              })
          }
        } else {
          Vue.prototype.alert('您的身份为空，请您从微信服务号进入')
          NProgress.done()
        }
      } else {
        const agent_id = Vue.prototype.CONST.AGENT_MAP[to.path]
        if (code && agent_id) {
          if (process.env.NODE_ENV === 'development') { // for test
            await store.dispatch('user/login', { username: '李宁', password: 'Windows886' })
              .then(async() => {
                await store.dispatch('user/getInfo').then(() => {
                  next()
                }).catch(() => {
                  Vue.prototype.alert('获取登录信息失败，请检查您的网络')
                  NProgress.done()
                })
              })
              .catch(() => {
                Vue.prototype.alert('验证身份失败，请您从企业微信端进入')
                NProgress.done()
              })
          } else {
            await store.dispatch('user/qywxLogin', { code: code, agent_id: agent_id })
              .then(async() => {
                await store.dispatch('user/getInfo').then(() => {
                  next()
                }).catch(() => {
                  Vue.prototype.alert('获取登录信息失败，请检查您的网络')
                  NProgress.done()
                })
              })
              .catch(() => {
                Vue.prototype.alert('验证身份失败，请您从企业微信端进入')
                NProgress.done()
              })
          }
        } else {
          Vue.prototype.alert('您的身份为空，请您从企业微信端进入')
          NProgress.done()
        }
      }
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/router-permission.js